import React from 'react'
import Title from '../Home/Title'
import Education from './Education'
import Skills from './Skills'

const Resume = () => {
  return (
    <section id="resume" className="w-full">
    <Title title="My" subTitle="Resume"/>
    <Education />
    <Title title="My" subTitle="Skills"/>
    <Skills />
    </section>
  )
}

export default Resume